import { get } from 'lodash';

export function getScreenDims() {
  return get(window, 'channel.channels[0].json_data.params.assetDimensions', {}) as {width?: string, height?: string};
}